/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminPlayerRestriction,
  ErrorResponse,
  FraudBlockPlayerRequest,
  FraudControlConfig,
  FraudControlConfigResponse,
  FraudOverrideRestrictionRequest,
  FraudRestrictionsAdminPage,
} from '../models/index';
import {
    AdminPlayerRestrictionFromJSON,
    AdminPlayerRestrictionToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FraudBlockPlayerRequestFromJSON,
    FraudBlockPlayerRequestToJSON,
    FraudControlConfigFromJSON,
    FraudControlConfigToJSON,
    FraudControlConfigResponseFromJSON,
    FraudControlConfigResponseToJSON,
    FraudOverrideRestrictionRequestFromJSON,
    FraudOverrideRestrictionRequestToJSON,
    FraudRestrictionsAdminPageFromJSON,
    FraudRestrictionsAdminPageToJSON,
} from '../models/index';

export interface BlockPlayerRequest {
    playerLookupId: string;
    customerId: string;
    fraudBlockPlayerRequest: FraudBlockPlayerRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetCurrentFraudRestrictionsRequest {
    customerId: string;
    resultStart: number;
    resultEnd: number;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetFraudControlConfigRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface OverrideRestrictionRequest {
    restrictionId: string;
    customerId: string;
    fraudOverrideRestrictionRequest: FraudOverrideRestrictionRequest;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdateFraudControlConfigRequest {
    customerId: string;
    fraudControlConfig: FraudControlConfig;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class FraudControlsApi extends runtime.BaseAPI {

    /**
     * Manually block a player from scanning indefinitely
     */
    async blockPlayerRaw(requestParameters: BlockPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPlayerRestriction>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling blockPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling blockPlayer().'
            );
        }

        if (requestParameters['fraudBlockPlayerRequest'] == null) {
            throw new runtime.RequiredError(
                'fraudBlockPlayerRequest',
                'Required parameter "fraudBlockPlayerRequest" was null or undefined when calling blockPlayer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:fraud-controls"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/fraud/player/{playerLookupId}/block`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FraudBlockPlayerRequestToJSON(requestParameters['fraudBlockPlayerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPlayerRestrictionFromJSON(jsonValue));
    }

    /**
     * Manually block a player from scanning indefinitely
     */
    async blockPlayer(requestParameters: BlockPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPlayerRestriction> {
        const response = await this.blockPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all players with a currently-active fraud restriction (lockout or probation)
     */
    async getCurrentFraudRestrictionsRaw(requestParameters: GetCurrentFraudRestrictionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FraudRestrictionsAdminPage>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCurrentFraudRestrictions().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling getCurrentFraudRestrictions().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling getCurrentFraudRestrictions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:fraud-controls"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/fraud/restrictions`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FraudRestrictionsAdminPageFromJSON(jsonValue));
    }

    /**
     * List all players with a currently-active fraud restriction (lockout or probation)
     */
    async getCurrentFraudRestrictions(requestParameters: GetCurrentFraudRestrictionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FraudRestrictionsAdminPage> {
        const response = await this.getCurrentFraudRestrictionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the ticket scan fraud control config for the customer
     */
    async getFraudControlConfigRaw(requestParameters: GetFraudControlConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FraudControlConfigResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getFraudControlConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:fraud-controls"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/fraud/config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FraudControlConfigResponseFromJSON(jsonValue));
    }

    /**
     * Get the ticket scan fraud control config for the customer
     */
    async getFraudControlConfig(requestParameters: GetFraudControlConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FraudControlConfigResponse> {
        const response = await this.getFraudControlConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Override (lift) a player\'s restriction
     */
    async overrideRestrictionRaw(requestParameters: OverrideRestrictionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['restrictionId'] == null) {
            throw new runtime.RequiredError(
                'restrictionId',
                'Required parameter "restrictionId" was null or undefined when calling overrideRestriction().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling overrideRestriction().'
            );
        }

        if (requestParameters['fraudOverrideRestrictionRequest'] == null) {
            throw new runtime.RequiredError(
                'fraudOverrideRestrictionRequest',
                'Required parameter "fraudOverrideRestrictionRequest" was null or undefined when calling overrideRestriction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:fraud-controls"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/fraud/restrictions/{restrictionId}/override`;
        urlPath = urlPath.replace(`{${"restrictionId"}}`, encodeURIComponent(String(requestParameters['restrictionId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FraudOverrideRestrictionRequestToJSON(requestParameters['fraudOverrideRestrictionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Override (lift) a player\'s restriction
     */
    async overrideRestriction(requestParameters: OverrideRestrictionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.overrideRestrictionRaw(requestParameters, initOverrides);
    }

    /**
     * Create or replace the ticket scan fraud control config for the customer
     */
    async updateFraudControlConfigRaw(requestParameters: UpdateFraudControlConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FraudControlConfig>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateFraudControlConfig().'
            );
        }

        if (requestParameters['fraudControlConfig'] == null) {
            throw new runtime.RequiredError(
                'fraudControlConfig',
                'Required parameter "fraudControlConfig" was null or undefined when calling updateFraudControlConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:fraud-controls"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/fraud/config`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FraudControlConfigToJSON(requestParameters['fraudControlConfig']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FraudControlConfigFromJSON(jsonValue));
    }

    /**
     * Create or replace the ticket scan fraud control config for the customer
     */
    async updateFraudControlConfig(requestParameters: UpdateFraudControlConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FraudControlConfig> {
        const response = await this.updateFraudControlConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
